// @ts-nocheck
import React, { useMemo } from 'react';
import { usePopupMode } from '../contexts/PopupContext';

const LOGO_SRC = `${process.env.PUBLIC_URL || ''}/assets/images/logo.png`;

/**
 * Shared layout for email + access-code auth steps.
 * Full split (hero + form) on standalone login; compact card-only when
 * embedded/popup (Salesforce utility bar, hideTitle, embed=1) so we don't
 * paint a marketing shell inside a docked panel.
 */
export default function LoginLayout({ children }) {
  const isPopupMode = usePopupMode();
  const compact = useMemo(() => {
    if (isPopupMode) return true;
    try {
      if (typeof window !== 'undefined' && window.self !== window.top) return true;
      const params = new URLSearchParams(window.location.search);
      if (params.get('hideTitle') === 'true') return true;
    } catch (_) {
      /* cross-origin iframe access can throw — treat as embedded */
      return true;
    }
    return false;
  }, [isPopupMode]);

  if (compact) {
    return (
      <div className="login-screen login-screen--compact">
        <div className="login-screen-panel login-screen-panel--compact d-flex align-items-center justify-content-center px-3 py-4 min-vh-100">
          <div className="login-form-container w-100">
            {children}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-screen">
      <div className="login-screen-inner row g-0 min-vh-100">
        <div className="col-lg-5 login-screen-hero d-none d-lg-flex flex-column justify-content-center align-items-center p-5">
          <div className="login-screen-hero-content text-center px-3">
            <img src={LOGO_SRC} alt="AvSight" className="login-screen-logo login-screen-logo--hero mb-4" />
            <p className="mb-0 text-white opacity-75" style={{ maxWidth: '22rem' }}>
              AI-assisted answers, feature voting, release notes, and support—all in one workspace after you sign in.
            </p>
          </div>
        </div>
        <div className="col-12 col-lg-7 login-screen-panel d-flex align-items-center justify-content-center px-3 py-4 py-lg-5">
          <div className="login-form-container w-100">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
